module.exports = __webpack_public_path__ + "img/related-post-01.3a490f40.jpg";